const gwAPIHandler = (baseUrl: string) => {
  const BASE_API_URL = baseUrl;

  const getQueryContent = async (queryId: string) => {
    return await fetch(`${BASE_API_URL}/v1/public/sql/content-queries`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        queryId: queryId,
        biscuits: [],
      }),
    });
  };

  const getVisuals = async (
    pageNo: number,
    pageSize: number,
    scope: string,
    searchPattern: string,
    sortBy: string,
    sortOrder: string,
    visibility: string,
    visualType: string
  ) => {
    const queryParams = new URLSearchParams({
      pageNo: pageNo.toString(),
      pageSize: pageSize.toString(),
      scope,
      searchPattern,
      sortBy,
      sortOrder,
      visibility,
      visualType,
    }).toString();

    return await fetch(`${BASE_API_URL}/v2/content/visuals?${queryParams}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
  };

  const getSubscription = async () => {
    return await fetch(`${BASE_API_URL}/v1/subscription`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
  };

  return {
    getQueryContent,
    getVisuals,
    getSubscription,
  };
};

export { gwAPIHandler };
